module.exports = __webpack_public_path__ + "assets/img/my-vip-title2.8058f17a.png";